import styled from "styled-components";
import Styles from "./Marquee.module.css";

const MarqueeText = (props) => {
  const htmlData = `
${props?.data?.text}
`;

  return (
    <div className={Styles.marquee}>
      <span
        className={Styles.movespan}
        dangerouslySetInnerHTML={{ __html: htmlData }}
      />
    </div>
  );
};
export default MarqueeText;
